import { render, staticRenderFns } from "./InYear.vue?vue&type=template&id=12472e51&"
import script from "./InYear.vue?vue&type=script&lang=js&"
export * from "./InYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports